//
//
//
//
//
//

  export default {
    props: {
      timeNum: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        time: 0,
        timer: null
      }
    },
    computed: {
      showTime() {
        let h = Math.floor(this.time / 3600)
        let m = Math.floor((this.time - h * 3600) / 60)
        let s = Math.floor((this.time - h * 3600) % 60)
        if (h < 10) h = '0' + h
        if (m < 10) m = '0' + m
        if (s < 10) s = '0' + s
        return { h, gap1: ':', m, gap2: ':', s }
      }
    },
    created() {
      this.initTime()
    },
    methods: {
      initTime() {
        this.time = this.timeNum * 1
        if (this.time > 0) {
          this.timer = setInterval(() => {
            this.time--
            if (this.time <= 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        }
      }
    },
    destroyed() {
      clearInterval(this.timer)
    }
  }



// WEBPACK FOOTER //
// ./src/common/components/g-count-down/index.vue